import { api } from '../../../../app/auth/apiSlice';

const notificationApi = api
  .enhanceEndpoints({
    addTagTypes: ['Notification'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getNotifications: builder.query<any, any>({
        query: ({ limit }) => {
          return `v1/notifications/notifications/?offset=${0}&limit=${limit}`;
        },
        providesTags: ['Notification'],
      }),
      postMarkReadNotifications: builder.mutation<any, void>({
        query: () => {
          return {
            url: `v1/notifications/notifications/mark-read`,
            method: 'PATCH',
          };
        },
        invalidatesTags: ['Notification'],
      }),
      postSeenNotification: builder.mutation<any, number | string>({
        query: (id) => {
          return {
            url: `v1/notifications/notifications/${id}/click/`,
            method: 'PATCH',
          };
        },
        invalidatesTags: ['Notification'],
      }),
    }),
  });

export const {
  useGetNotificationsQuery,
  usePostMarkReadNotificationsMutation,
  usePostSeenNotificationMutation,
} = notificationApi;
